import React, { Fragment } from 'react';
import { Media, Col, Row } from 'reactstrap';
import { H6, P, Btn } from '../../../../AbstractElements';
import { Link } from 'react-router-dom';

var images = require.context('../../../../assets/images', true);

const AllEmailsClass = ({ list, selectMailCallback, selectedmailCallback, checked }) => {
  const dynamicImage = (image) => {
    return images(`./${image}`);
  };

  return (
    <Fragment>
      <Media onClick={() => selectMailCallback(list)}>
        {/* <Label className="d-block" htmlFor="chk-ani">
                    <Input className="checkbox_animated"
                        name="chk-ani" type="checkbox" onChange={(e) => selectedmailCallback(e, list.id)} defaultChecked={checked} />
                </Label> */}
				
				 <Row style={{width:'100%'}}>
     <Col style={{width:'70%'}}>
         
		 <Media body>
          <H6>
            {list.name}
            <small>
              <span className='digits'>{" "}({"  "+list.date})</span>
            </small>
          </H6>
          <P>{list.cc},</P>
        </Media>
      </Col>
	  
              <Col className="text-end" style={{width:'30%'}}>
					
                    <Link to={`${process.env.PUBLIC_URL}/dpsm/scheme/track-application/ltp/`+list.id} > 				  
				         <Btn attrBtn={{ color: 'success', className: 'me-3' }}>{"Track Application"}</Btn>
				      </Link>
						
                    </Col>
                </Row>
       
         </Media>
	  
	  
	  
	  
    </Fragment>
  );
};

export default AllEmailsClass;
